<template>
  <div>
    <CRow class="mb-3">
      <CCol sm="6">
        <label>{{ $pgettext('tag_definitions.form', 'Placeholder') }}</label>
        <CInput
            v-model="config.placeholder"
            :placeholder="$pgettext('tag_definitions.placeholder', 'Enter placeholder text')"
        />
      </CCol>
      <CCol sm="6">
        <label>{{ $pgettext('tag_definitions.form', 'Max Length') }}</label>
        <CInput
            type="number"
            v-model.number="config.max_length"
            :placeholder="$pgettext('tag_definitions.placeholder', 'Max 500')"
            min="1"
            max="500"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
export default {
  name: "TextInputConfig",
  data() {
    return {
      config: {
        type: 'text',
        placeholder: '',
        max_length: null
      }
    }
  },
  methods: {
    onReset(data) {
      this.config = {
        type: 'text',
        placeholder: '',
        max_length: null,
        ...data
      }
    },
    onSave() {
      return this.config
    }
  }
}
</script>
